module.exports = __webpack_public_path__ + "static/media/jackbanner_sm3.964ae958.png";